import styled from '@emotion/styled';
import Button from '../controls/button/Button.component';

export interface navbarProps {
  activeTab?: boolean;
  showHamburgerMenu?: boolean
}

export const NavContainer = styled.div<navbarProps>`
  width: 100%;
  height: 10vh;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 0px;
  @media screen and (max-width: 767px) {
    justify-content: (({ showHamburgerMenu }) => (showHamburgerMenu? 'space-between' : ''));
)
  }
`;
export const Content = styled.div`
  width: 97%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const LinkTab = styled.span<navbarProps>`
  border-bottom: ${({ activeTab }) =>
    activeTab ? '3px solid #86B817' : 'none'};
  cursor: pointer;
  margin: 0px 18px;
  :nth-child(1) {
    margin-left: 60px;
  }
  transition: 0.1s linear
`;

export const StyledNavButton = styled(Button)`
  margin: 0px 5px;
`;
